var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guestReviews"},[_c('GuestReviewTable',{key:_vm.sensitiveKey,staticClass:"guestReviews-table",class:(_vm.$vuetify.breakpoint.xsOnly ? 'xs mt-4' :'' )})],1)}
var staticRenderFns = []

export { render, staticRenderFns }